import { useState } from 'react';
import type { ICustomControlProcedureDiagnosticReportReadProps } from '@frontend/components/pages/customControls/interfaces';
import { getServiceLabel } from '@common/customControls/getServiceLabel';
import { RequestStatus, ServiceType } from '@common/enums/index';
import { getDisplayName } from '@common/utils/getDisplayName';
import { ProcedureDiagnosticReportReadButtons } from '@frontend/components/elements/carePathButtons/ProcedureDiagnosticReportReadButtons';
import { FormGroupRead } from '@frontend/components/pages/customControls/utils/v1/FormGroupRead';
import { translateKey } from '@frontend/translate';
import { ProcessContainer } from '../../../episodes/common';
import { ProcessItemHeader } from '../../../episodes/ProcessItemHeader';
import { CustomControlCollapseBody } from '../../utils/v1/CustomControlCollapseBody';

export function OcrkV1RequestReadOork(props: ICustomControlProcedureDiagnosticReportReadProps) {
    const [isOpen, setIsOpen] = useState(props.itemState.isOpen);

    if (props.request.status === RequestStatus.completed || !props.procedure.customControlData.consult) {
        return null;
    }

    return (
        <ProcessContainer isActiveActivity={props.itemState.initialIsOpen}>
            <ProcessItemHeader
                isFirstItem={props.isFirstItem}
                isFirstProcess={props.itemState.isFirstProcess}
                isItemOpen={isOpen}
                onToggle={(isOpened) => setIsOpen(isOpened)}
                organizationName={props.procedure.performerOrganization.name}
                practitionerName={
                    props.procedure.performerPractitioner
                        ? getDisplayName(props.procedure.performerPractitioner)
                        : undefined
                }
                process={props.process}
                serviceType={ServiceType.consultation}
                showProcessIcon={true}
                title={getServiceLabel(props.process.code, 'diagnosticReport', translateKey('request.consult'))}
            />

            <CustomControlCollapseBody isOpen={isOpen}>
                <FormGroupRead
                    label="Vraag"
                    value={props.procedure.customControlData.consult.question}
                />
                <FormGroupRead
                    label="Toelichting"
                    value={props.procedure.customControlData.consult.toelichting}
                />
            </CustomControlCollapseBody>

            <ProcedureDiagnosticReportReadButtons
                {...props}
                hidePrintButton={true}
                toastServiceLabelType="toast"
            />
        </ProcessContainer>
    );
}
